import React, { useRef, useEffect, useState, useCallback } from "react";
import useWindowSize from "Utils/useWindowSize";
import s from "./pricesTable.scss";
import cx from "classnames";
import TranslatedString from "Components/TranslatedString";
import Loader from "Components/loader/Loader";
import { priceFormat } from "Utils/strings";
import { t } from "i18next";

const formatPricesForTable = (standardTiers) => {
  let plans = {};
  let tiers = {};

  for (let key in standardTiers) {
    const tier = standardTiers[key];
    tiers[key] = {};

    let pricesPerPlan = {};
    for (let k in tier) {
      if (["basic", "professional", "enterprise"].includes(k)) {
        pricesPerPlan[k] = {};
        if (!tiers[key][k]) {
          tiers[key][k] = {};
        }

        let sizesPrizes = tier[k];
        for (let size in sizesPrizes) {
          if (!tiers[key][k][size]) tiers[key][k][size] = [];

          tiers[key][k][size] = sizesPrizes[size];
        }
      }
    }
  }

  for (let tier in tiers) {
    for (let plan in tiers[tier]) {
      if (!plans[plan]) plans[plan] = {};

      for (let size in tiers[tier][plan]) {
        if (!plans[plan][size]) plans[plan][size] = [];

        plans[plan][size].push({ amount: priceFormat(tiers[tier][plan][size]) });
      }
    }
  }
  return plans;
};

const PricesTable = (props) => {
  const { currentTier, standardTiers, isAnnual } = props;

  const [headers, setHeaders] = useState([
    { label: `10 - 49 <br />${t("prices.tableLabel.mailboxes")}` },
    { label: `50 - 99 <br />${t("prices.tableLabel.mailboxes")}` },
    { label: `100 - 199 <br />${t("prices.tableLabel.mailboxes")}` },
  ]);

  const [highlightStyles, setHighlightStyles] = useState(null);
  const [tables, setTables] = useState(null);

  const [hightlightIndex, setHighlightIndex] = useState(0);

  const size = useWindowSize();

  const sizeColRef = useRef(null);
  const getColRef = useCallback((node) => {
    if (!node) return;
    sizeColRef.current = node;
    calcHighlightPosition(node);
  }, []);

  useEffect(() => {
    if (!standardTiers) return;
    setTables(formatPricesForTable(standardTiers));

    if (Object.keys(standardTiers).length > 3 && Object.keys(headers).length !== 4) {
      setHeaders([{ label: `5 - 9 <br/>${t("prices.tableLabel.mailboxes")}` }, ...headers]);
    }
  }, [standardTiers]);

  useEffect(() => {
    if (!sizeColRef.current) return;

    calcHighlightPosition(sizeColRef.current);
  }, [currentTier, size]);

  const calcHighlightPosition = (node) => {
    const dimensions = node.getBoundingClientRect();

    let currentIndex = 0;
    for (let i in standardTiers) {
      currentIndex++;
      if (standardTiers[i].whmcs_product === currentTier) {
        break;
      }
    }

    setHighlightIndex(currentIndex);

    setHighlightStyles({
      left: dimensions.width * currentIndex,
      width: dimensions.width + 1,
    });
  };

  if (!tables) return <Loader />;

  return (
    <>
      <div className={s.priceTablesContainer}>
        <div className={s.priceHighlight} style={highlightStyles}></div>

        <table className={cx(s.headerTable)}>
          <tbody>
            <tr>
              <td style={{ visibility: "hidden" }}></td>
              {headers.map((h, index) => (
                <td key={h.label}>
                  <div
                    className={cx(s.priceTableHeader, {
                      [s.selected]: hightlightIndex == index + 1,
                    })}
                    dangerouslySetInnerHTML={{ __html: h.label }}
                  ></div>
                </td>
              ))}
            </tr>
          </tbody>
        </table>

        {Object.entries(tables).map(([planName, sizes], indexPlans) => (
          <table key={planName} className={cx(s.priceTable, s.basicTable)}>
            <thead>
              <tr>
                <th colSpan={headers.length + 1}>{planName}</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(sizes).map(([size, prices], index) => (
                <tr key={size}>
                  <td ref={index == 0 && indexPlans == 0 ? getColRef : null} id={`col-${index}`}>
                    {size} GB
                  </td>
                  {prices.map((price, index) => (
                    <td
                      className={cx({
                        [s.selected]: hightlightIndex == index + 1,
                      })}
                      key={price.amount + index}
                    >
                      € {price.amount}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        ))}
      </div>

      <p className="mt-2 text-xs">
        <TranslatedString>{isAnnual ? "prices.disclaimerAnnual" : "prices.disclaimer"}</TranslatedString>
      </p>
    </>
  );
};

export default PricesTable;
